let common = require('../admin-common.js');

$(document).on('click', '.clear-deadlines-search', function() {
  $('#q_school_code_cont').val('');
  $('#q_order_set_code_cont').val('');
  $('#q_order_set_order_set_name_cont').val('');
  $('#q_order_set_school_year_eq').val('');
  $('#q_school_school_name_cont').val('');
});

$(document).on('click', '.export-csv-deadlines', function() {
  let params = window.location.search.substr(1);
  let url = '/agency/deadlines/export?' + params;
  window.open(url);
});

$(document).on('click', '.clear-list-schools-search', function() {
  $('#order_set_code_select').val('').trigger('change');
  $('#q_territories_school_name_cont').val('');
  $('#q_deadline_status_eq').val('9');
  $('#q_territories_year_eq').val('');
});

$(document).on('change', '.school-item-checkbox', function () {
  const schoolId = $(this).data('school-id');
  const isChecked = $(this).is(':checked');

  $(`.deadline-date-input[data-school-id='${schoolId}']`).prop('disabled', !isChecked);
  $(`.management-div-input[data-school-id='${schoolId}']`).prop('disabled', !isChecked);
});

function showWarningModal(type) {
  $('#warning-apply-message, #warning-register-message').hide();
  if (type === 'apply') {
    $('#warning-apply-message').show();
  } else if (type === 'register') {
    $('#warning-register-message').show();
  }
  $('#warning-not-data-modal').modal('show');
}

function applyValueToCheckedSchools(triggerSelector, sourceInputId, targetInputClass) {
  $(document).on('click', triggerSelector, function (e) {
    if ($('.school-item-checkbox:checked').length > 0) {
      const selectedValue = document.getElementById(sourceInputId).value;

      $('.school-item-checkbox:checked').each(function (_, checkbox) {
        const schoolId = checkbox.dataset.schoolId;
        const target = $(`.${targetInputClass}[data-school-id='${schoolId}']`);

        if (!target.data('readonly')) {
          target.val(selectedValue);
        }
      });
    } else {
      e.preventDefault();
      showWarningModal('apply')
    }
  });
}

applyValueToCheckedSchools('#submit-deadline-date', 'deadline_date', 'deadline-date-input');
applyValueToCheckedSchools('#submit-management-div', 'management_div', 'management-div-input');

$(document).on('submit', '#bulk_register_deadline', function (e) {
  const selectedSchools = document.querySelectorAll('.school-item-checkbox:checked');
  if (selectedSchools.length > 0) {
    const container = document.getElementById('selected-school-fields');
    container.innerHTML = '';

    const createHiddenInput = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      container.appendChild(input);
    };

    selectedSchools.forEach((checkbox) => {
      const schoolId = checkbox.dataset.schoolId;
      const deadlineDate = document.querySelector(`.deadline-date-input[data-school-id='${schoolId}']`)?.value;
      const managementDiv = document.querySelector(`.management-div-input[data-school-id='${schoolId}']`)?.value;

      createHiddenInput('deadlines[][school_type]', schoolId.substring(0, 1));
      createHiddenInput('deadlines[][school_code]', schoolId.substring(1));
      createHiddenInput('deadlines[][deadline_date]', deadlineDate);
      createHiddenInput('deadlines[][management_div]', managementDiv);
    });
  } else {
    e.preventDefault();
    showWarningModal('register')
  }
});

$(document).ready(function () {
  const $storeSelect = $('#store_id_select');
  const $orderSetSelect = $('#order_set_code_select');
  const $territoryYearSelect = $('#q_territories_year_eq');

  $orderSetSelect.select2({ language: common.noResultMessage, width: '100%' });

  $territoryYearSelect.on('change', function () {
    let territoryYear = $(this).val();
    $orderSetSelect.val('').trigger('change');

    if (territoryYear) {
      let storeId = $storeSelect.data('store-id');

      $.ajax({
        url: '/agency/deadlines/load_order_sets',
        method: 'GET',
        data: { store_id_eq: storeId, territories_year_eq: territoryYear},
        dataType: 'json',
        success: function (data) {
          $orderSetSelect.find('option:not([value=""])').remove();
                    data.order_set_options.forEach(function (item) {
            $orderSetSelect.append(
              $('<option>', { value: item.id, text: item.text })
            );
          });

          $orderSetSelect.trigger('change');
        },
      });
    }
  });
});
